// extracted by mini-css-extract-plugin
export default {"avatar":"User_avatar__Z1sKJ","cutText":"User_cutText__G5E6k","userMenuBlock":"User_userMenuBlock__V8qoT"};